import { Autocomplete, Checkbox, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'

export const AutocompleteStyled = styled(Autocomplete)((theme) => ({}))

export const CheckboxStyled = styled(Checkbox)((theme) => ({}))

export const TextFieldStyled = styled(TextField)((theme) => ({}))

